import React, { useState } from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import ActionButton from '../../common/ActionButton';
import { ModalConfirmationWithErrorAndLoader } from '../../common/ModalConfirmationWithErrorAndLoader';
import { TUser } from '../../../types';
import { executeHttpRequest } from '../../../epics/api';
import { getErrorMessages } from '../../../utils';
import { ROOT_URL_V2 } from '../../../config';

type TDelegatedJobReportProps = {
    user: TUser;
}

export default function DelegatedJobReport({ user }: TDelegatedJobReportProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [dateFrom, setDateFrom] = useState<Date | null>(null);
    const [dateTo, setDateTo] = useState<Date | null>(null);

    const openModal = () => setIsModalOpen(true);

    const closeModal = () => setIsModalOpen(false);

    const showActionButton = user.isAgent && user.agency.features.includes('delegate_jobs');

    const formatDate = (date: Date) => moment(date).format('YYYY-MM-DD');

    const handleContinue = () => {
        setIsLoading(true);
        setError(null);

        const path = `delegated-jobs/?date_from=${formatDate(dateFrom)}&date_to=${formatDate(dateTo)}`;

        executeHttpRequest(path)
            .then(() => {
                setIsLoading(false);
                setIsModalOpen(false);
                setDateFrom(null);
                setDateTo(null);
                window.location.href = `${ROOT_URL_V2}${path}&format=sync-csv`;
            })
            .catch(err => {
                setError(getErrorMessages(err));
                setIsLoading(false);
            });
    };

    return (
        <>
            <ActionButton
                iconClass="icon-navigation-next-4"
                tooltip="Delegated Job Report"
                onAction={openModal}
                show={showActionButton}
            />
            {isModalOpen && (
                <ModalConfirmationWithErrorAndLoader
                    className="delegated-job-report"
                    errorMessage={error}
                    handleCancel={closeModal}
                    handleContinue={handleContinue}
                    isError={!!error}
                    isInProgress={isLoading}
                    setIsInProgress={setIsLoading}
                    isOpen={isModalOpen}
                    title="Delegated Job Report"
                    continueEnabled={!!(dateFrom && dateTo)}
                >
                    <p className="modal-title">Delegated Jobs Report</p>
                    <p>Please select a date range from which you want to generate a Delegated Job Report:</p><br/>
                    <DatePicker
                        className="delegated-job-report-date-field"
                        selected={dateFrom}
                        onChange={([start, end]) => {
                            setDateFrom(start);
                            setDateTo(end);
                        }}
                        startDate={dateFrom}
                        endDate={dateTo}
                        selectsRange={true}
                        dateFormat="dd/MM/yyyy"
                        showMonthDropdown={true}
                        showYearDropdown={true}
                        calendarStartDay={1}
                        placeholderText="Select date range"
                    />
                </ModalConfirmationWithErrorAndLoader>
            )}
        </>
    );
}
